import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "time-blocks" }

import timePart from "./time-part.vue";
import type { PropType } from "vue";
import type { TimeParts } from "./types";


export default /*@__PURE__*/_defineComponent({
  __name: 'time-parts',
  props: {
    value: {
        type: Object as PropType<TimeParts>,
        required: true,
    },
    secondsLeft: {
        type: Number,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(timePart, {
      value: __props.secondsLeft > 0 ? __props.value.days.value : 0,
      unit: __props.value.days.unit
    }, null, 8 /* PROPS */, ["value", "unit"]),
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "time-block-separator" }, null, -1 /* HOISTED */)),
    _createVNode(timePart, {
      value: __props.secondsLeft > 0 ? __props.value.hours.value : 0,
      unit: __props.value.hours.unit
    }, null, 8 /* PROPS */, ["value", "unit"]),
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "time-block-separator" }, null, -1 /* HOISTED */)),
    _createVNode(timePart, {
      value: __props.secondsLeft > 0 ? __props.value.minutes.value : 0,
      unit: __props.value.minutes.unit
    }, null, 8 /* PROPS */, ["value", "unit"]),
    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "time-block-separator" }, null, -1 /* HOISTED */)),
    _createVNode(timePart, {
      value: __props.secondsLeft > 0 ? __props.value.seconds.value : 0,
      unit: __props.value.seconds.unit
    }, null, 8 /* PROPS */, ["value", "unit"])
  ]))
}
}

})